export const MoreTemplates = () => {
  return (
    <svg
      width="67"
      height="56"
      viewBox="0 0 67 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="25.5162"
        y="36.4503"
        width="19.4838"
        height="19.4837"
        rx="4.88033"
        fill="url(#paint0_linear_2461_17871)"
      />
      <rect
        x="25.5162"
        y="36.4503"
        width="19.4838"
        height="19.4837"
        rx="4.88033"
        fill="black"
        fill-opacity="0.1"
      />
      <path
        d="M34.4904 41.3304H36.0256V51.0535H34.4904V41.3304Z"
        fill="white"
      />
      <path
        d="M30.3963 45.4244H40.1194V46.9597H30.3963V45.4244Z"
        fill="white"
      />
      <path
        d="M0.581787 3.2613C0.581787 1.59295 1.93426 0.240479 3.60261 0.240479H21.4721C23.1405 0.240479 24.4929 1.59295 24.4929 3.26131V20.3836C24.4929 22.0519 23.1405 23.4044 21.4721 23.4044H3.60261C1.93426 23.4044 0.581787 22.0519 0.581787 20.3836V3.2613Z"
        fill="url(#paint1_linear_2461_17871)"
      />
      <path
        d="M0.581787 3.2613C0.581787 1.59295 1.93426 0.240479 3.60261 0.240479H21.4721C23.1405 0.240479 24.4929 1.59295 24.4929 3.26131V20.3836C24.4929 22.0519 23.1405 23.4044 21.4721 23.4044H3.60261C1.93426 23.4044 0.581787 22.0519 0.581787 20.3836V3.2613Z"
        fill="black"
        fill-opacity="0.1"
      />
      <g opacity="0.7">
        <path
          d="M4.30185 13.4535C4.30185 13.1753 4.52733 12.9498 4.80548 12.9498H16.501C16.7792 12.9498 17.0046 13.1753 17.0046 13.4535V14.6879C17.0046 14.966 16.7792 15.1915 16.501 15.1915H4.80548C4.52733 15.1915 4.30185 14.966 4.30185 14.6879V13.4535Z"
          fill="url(#paint2_linear_2461_17871)"
        />
        <path
          d="M4.30185 13.4535C4.30185 13.1753 4.52733 12.9498 4.80548 12.9498H16.501C16.7792 12.9498 17.0046 13.1753 17.0046 13.4535V14.6879C17.0046 14.966 16.7792 15.1915 16.501 15.1915H4.80548C4.52733 15.1915 4.30185 14.966 4.30185 14.6879V13.4535Z"
          fill="black"
          fill-opacity="0.1"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M4.30185 17.9367C4.30185 17.6586 4.52733 17.4331 4.80548 17.4331H16.501C16.7792 17.4331 17.0046 17.6586 17.0046 17.9367V19.1711C17.0046 19.4493 16.7792 19.6748 16.501 19.6748H4.80548C4.52733 19.6748 4.30185 19.4493 4.30185 19.1711V17.9367Z"
          fill="url(#paint3_linear_2461_17871)"
        />
        <path
          d="M4.30185 17.9367C4.30185 17.6586 4.52733 17.4331 4.80548 17.4331H16.501C16.7792 17.4331 17.0046 17.6586 17.0046 17.9367V19.1711C17.0046 19.4493 16.7792 19.6748 16.501 19.6748H4.80548C4.52733 19.6748 4.30185 19.4493 4.30185 19.1711V17.9367Z"
          fill="black"
          fill-opacity="0.1"
        />
      </g>
      <circle
        cx="6.10108"
        cy="7.2367"
        r="2.72437"
        fill="url(#paint4_linear_2461_17871)"
      />
      <path
        d="M42.5818 7.2613C42.5818 5.59295 43.9343 4.24048 45.6026 4.24048H63.4721C65.1405 4.24048 66.4929 5.59295 66.4929 7.26131V24.3836C66.4929 26.0519 65.1405 27.4044 63.4721 27.4044H45.6026C43.9343 27.4044 42.5818 26.0519 42.5818 24.3836V7.2613Z"
        fill="url(#paint5_linear_2461_17871)"
      />
      <path
        d="M42.5818 7.2613C42.5818 5.59295 43.9343 4.24048 45.6026 4.24048H63.4721C65.1405 4.24048 66.4929 5.59295 66.4929 7.26131V24.3836C66.4929 26.0519 65.1405 27.4044 63.4721 27.4044H45.6026C43.9343 27.4044 42.5818 26.0519 42.5818 24.3836V7.2613Z"
        fill="black"
        fill-opacity="0.1"
      />
      <g opacity="0.7">
        <path
          d="M46.3018 17.4535C46.3018 17.1753 46.5273 16.9498 46.8055 16.9498H58.501C58.7792 16.9498 59.0046 17.1753 59.0046 17.4535V18.6879C59.0046 18.966 58.7792 19.1915 58.501 19.1915H46.8055C46.5273 19.1915 46.3018 18.966 46.3018 18.6879V17.4535Z"
          fill="url(#paint6_linear_2461_17871)"
        />
        <path
          d="M46.3018 17.4535C46.3018 17.1753 46.5273 16.9498 46.8055 16.9498H58.501C58.7792 16.9498 59.0046 17.1753 59.0046 17.4535V18.6879C59.0046 18.966 58.7792 19.1915 58.501 19.1915H46.8055C46.5273 19.1915 46.3018 18.966 46.3018 18.6879V17.4535Z"
          fill="black"
          fill-opacity="0.1"
        />
      </g>
      <g opacity="0.7">
        <path
          d="M46.3018 21.9367C46.3018 21.6586 46.5273 21.4331 46.8055 21.4331H58.501C58.7792 21.4331 59.0046 21.6586 59.0046 21.9367V23.1711C59.0046 23.4493 58.7792 23.6748 58.501 23.6748H46.8055C46.5273 23.6748 46.3018 23.4493 46.3018 23.1711V21.9367Z"
          fill="url(#paint7_linear_2461_17871)"
        />
        <path
          d="M46.3018 21.9367C46.3018 21.6586 46.5273 21.4331 46.8055 21.4331H58.501C58.7792 21.4331 59.0046 21.6586 59.0046 21.9367V23.1711C59.0046 23.4493 58.7792 23.6748 58.501 23.6748H46.8055C46.5273 23.6748 46.3018 23.4493 46.3018 23.1711V21.9367Z"
          fill="black"
          fill-opacity="0.1"
        />
      </g>
      <circle
        cx="48.1011"
        cy="11.2367"
        r="2.72437"
        fill="url(#paint8_linear_2461_17871)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2461_17871"
          x1="29.5193"
          y1="36.4503"
          x2="47.3084"
          y2="56.3803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2461_17871"
          x1="5.49448"
          y1="0.240479"
          x2="26.5573"
          y2="24.5994"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2461_17871"
          x1="6.91172"
          y1="12.9498"
          x2="7.54494"
          y2="16.9699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2461_17871"
          x1="6.91172"
          y1="17.4331"
          x2="7.54494"
          y2="21.4532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2461_17871"
          x1="3.37671"
          y1="7.2367"
          x2="8.82545"
          y2="7.2367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F7FDFC" />
          <stop offset="1" stop-color="#F7FDFC" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2461_17871"
          x1="47.4945"
          y1="4.24048"
          x2="68.5573"
          y2="28.5994"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2461_17871"
          x1="48.9117"
          y1="16.9498"
          x2="49.5449"
          y2="20.9699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2461_17871"
          x1="48.9117"
          y1="21.4331"
          x2="49.5449"
          y2="25.4532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#026051" />
          <stop offset="1" stop-color="#3B5F59" stop-opacity="0" />
          <stop offset="1" stop-color="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2461_17871"
          x1="45.3767"
          y1="11.2367"
          x2="50.8255"
          y2="11.2367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F7FDFC" />
          <stop offset="1" stop-color="#F7FDFC" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
